<template>
  <v-dialog
    v-model="dialog"
    width="448"
    open-on-focus
    no-click-animation
    persistent
    content-class="templates-select-dialog"
    @click:outside="onClickOutside"
    @keydown="onKeydown"
  >
    <v-card elevation="0">
      <v-form ref="form" class="templates-select-form" @submit.prevent="onSubmit">
        <div class="templates-select-form-body">
          <v-toolbar
            flat
            height="76"
          >
            <v-toolbar-title class="templates-select-toolbar-title">Sprints</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn
              color="accent"
              icon
              tile
              @click="closeDialog"
            >
              <v-icon size="24">mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-container class="templates-select-card-container">
            <dialog-input
              label="Search"
              name="search"
              :val="queryParams.q"
              @input="onSearch" />
          </v-container>
         
          <v-container class="templates-select-card-container pt-0">
            <v-row>
              <v-col sm="12">
                <main-user-table
                  :items="templatesList"
                  :items-per-page="queryParams.pageSize"
                  :server-items-length="pagination.totalCount || -1"
                  :page="queryParams.page"
                  :row-component="'templates-select-table-row'"
                  @to-user="onInput"
                  @action:get-data="getDataAction"
                />
              </v-col>
            </v-row>
          </v-container>
          <v-container v-if="startDateRequired" class="templates-select-card-container pt-0">
            <v-row>
              <v-col sm="12">
                <dialog-date-picker
                  label="Start date"
                  name="startDate"
                  :value="templateStartDate"
                  :initial-date="$moment().format('YYYY-MM-DD')"
                  @input="setDate" />
              </v-col>
            </v-row>
          </v-container>
        </div>
        <v-container class="templates-select-card-footer d-flex justify-end">
          <v-btn
            :disabled="!formIsValidCheck"
            rounded
            color="primary"
            type="submit"
            elevation="0"
          >
            Apply
          </v-btn>
        </v-container>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapActions } from "vuex";
import DialogInput from '@/components/forms/DialogInput.vue'
import DialogDatePicker from '@/components/forms/DialogDatePicker.vue'
import MainUserTable from "@/components/tables/MainUserTable"
import RouterMixin from "@/mixins/router"

export default {
  name: 'TemplatesDialog',
  components: {
    DialogInput,
    DialogDatePicker,
    MainUserTable
  },
  mixins: [RouterMixin],
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    templateSelected: {
      type: [Boolean, Number],
      default: false
    }
  },
  data () {
    return {
      dialog: false,
      templateToApply: false,
      templateStartDate: false,
      startDateRequired: false,
      formIsValidCheck: false
    }
  },
  watch: {
    showDialog: function (val) {
      if (val) {
        this.dialog = true
      }
    },
    templateSelected: function (val) {
      this.templateToApply = this.templateSelected
    }
  },
  computed: {
    ...mapState('templatesStates', [
      'templates',
      'template',
      'loading',
      'pagination'
    ]),
    templatesList() {
      let arr = []
      this.templates.forEach(item=>{
        let tmp = {...item}
        tmp.selected = false
        if (this.templateSelected == tmp.id || this.templateToApply == tmp.id) tmp.selected = true
        arr.push(tmp)
      })
      return arr
    }
  },
  methods: {
    ...mapActions('templatesStates', [
      'getTemplates'
    ]),
    getData(data) {
      this.getTemplates(data)
    },
    closeDialog () {
      this.dialog = false
      this.templateToApply = false
      this.templateStartDate = false
      this.startDateRequired = false
      this.$emit('close-dialog')
    },
    onClickOutside() {
      this.closeDialog()
    },
    onKeydown(key) {
      if (key.code === "Escape" && key.isTrusted) this.closeDialog()
    },
    onSearch (search) {
      this.getDataAction({ ...this.queryParams, q: search.value })
    },
    onSubmit () {
      this.$emit('on-submit', {templateId: this.templateToApply, startDate: this.templateStartDate})
      this.closeDialog()
    },
    formIsValid() {
      if (this.templateToApply) {
        this.formIsValidCheck = true
        if (this.startDateRequired && !this.templateStartDate) this.formIsValidCheck = false
      }
      else {
        this.formIsValidCheck = false
      }
    },
    setDate({id, value}) {
      this.templateStartDate = value
      this.formIsValid()
    },
    onInput ({id, value, isProcedureDateRelated}) {
      if (value==0) {
        this.templateToApply = false
      }
      else this.templateToApply = id
      this.startDateRequired = !isProcedureDateRelated
      if (!isProcedureDateRelated) this.templateStartDate = this.$moment().format('YYYY-MM-DD')
      this.formIsValid()
    },
  }
}
</script>

<style lang="scss">
@import "@/styles/variables.scss";

.templates-select {
  &-dialog {
    margin: $gutter;
    margin-left: auto;
    height: 100%;
    max-height: calc(100% - #{2*$gutter}) !important;
    // looks little hacky
    > .v-card {
      width: 100%;
      height: 100%;
    }
  }
  &-toolbar-title {
    color: $bh-blue;
    font-size: 1.5715rem;
    font-weight: bold;
  }
  &-card {
    &-title {
      font-size: $font-size-root;
      color: $bh-blue;
      padding-left: 1.5*$gutter;
      padding-right: 1.5*$gutter;
    }
    &-container {
      padding-left: 1.5*$gutter;
      padding-right: 1.5*$gutter;
    }
    &-footer {
      padding: 1.5*$gutter;
    }
  }
  &-file-button {
    margin-right: 10px;
    .v-icon {
      &:first-child {
        padding-right: 10px;
      }
      &:last-child {
        padding-left: 10px;
      }
    }
  }
  &-file-details {
    display: inline-block;
    img {
      width: 40px;
      height: 40px;
      display: inline-block;
      vertical-align: middle;
      object-fit: cover;
      margin-right: 10px;
    }
    .v-progress-circular {
      margin-right: 10px;
    }
    .v-icon {
      margin-left: 5px;
      padding:4px;
    }
  }
  &-form {
    background-color: $bh-blue--4;
    height: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    overflow: auto;

    &-body {
      ::v-deep .v-toolbar__content {
        padding-left: 1.5*$gutter;
        padding-right: 1.5*$gutter;
      }
    }
    &-col-left {
      padding-top: 0;
      padding-right: 0.25*$gutter;
    }
    &-col-right {
      padding-top: 0;
      padding-left: 0.25*$gutter
    }
  }
}
</style>
